import style from './style.css';
import { Fragment } from 'preact';
import { useDispatch, useSelector } from 'react-redux';
import withBaseComponent from '../../../HOC/withBaseComponent';
import OverlayEmiDetails from '../overlayEmiDetails';
import { useEffect, useState } from 'preact/hooks';
import OverlayScreen from '../overlayScreen';
import ntbAction from '../../../actions/ntbAction';
import PreApprovedContainer from './preApprovedContainer';
import KnowMoreButton from './knowMoreButton';
import actionType from '../../../actions/ntbAction/actionType';
import { overLayHeights } from '../../../constants';
import { tracker, PageLoadType } from '../../../tracking';
import PostTxnContainer from './postTxnContainer';
import { route } from 'preact-router';
import { transactionHistoryRoute } from '../../../alias/homeRoutes';
import { generateUrlWithParams } from '../../../utils/routeHandler';
import { getLenderNames } from '../../../utils/stringOperations';

const PreApprovedCard = ({ lenderDetailsList, matches }) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const isViewTxnUserCard =
    matches.utm_source && matches.utm_source.includes('txn_success');

  const pageKey = 'pv_bic_context_card';
  const overlaySizeClassName = 'overlay-wd-medium';
  const overlayHeight = overLayHeights.emiInfoHeight;

  const sendOtpResponse = useSelector((state) => state.ntbConfig);

  if (
    sendOtpResponse.showEligibilityModal &&
    sendOtpResponse.userStatus === 'eligible'
  ) {
    setShowOverlay(true);
  }

  const handleCloseOverlay = () => {
    setShowOverlay(false);
    const dispatch = useDispatch();
    dispatch(ntbAction(actionType.closeEligibilityModal));
  };

  useEffect(() => {
    if (showOverlay) {
      return (document.body.style.overflowY = 'hidden');
    }
    document.body.style.overflowY = 'auto';
  }, [showOverlay]);

  useEffect(() => {
    return tracker.trackPageView(PageLoadType.DYNAMIC, pageKey, {
      status: 'approved',
      lenderList: getLenderNames(lenderDetailsList),
    });
  }, []);

  const lendersRemaining = lenderDetailsList && lenderDetailsList.length - 2;

  return (
    <Fragment>
      <div className={style.checkEligibilityContainer}>
        <div className={style.cardContainer}>
          <div className={style.cardWrapper}>
            {isViewTxnUserCard ? (
              <Fragment>
                <PostTxnContainer />
                <div className={style.submitContainer}>
                  <KnowMoreButton
                    buttonId='view-all-txn-button'
                    pageKey={pageKey}
                    elementName='bic_view_all_txn'
                    buttonText={<Fragment>View All Txn</Fragment>}
                    buttonOnClick={() => {
                      route(
                        generateUrlWithParams(transactionHistoryRoute.path),
                      );
                    }}
                  />
                </div>
              </Fragment>
            ) : (
              <Fragment>
                <PreApprovedContainer />
                <div className={style.submitContainer}>
                  <KnowMoreButton
                    buttonId='know-more-button'
                    pageKey={pageKey}
                    elementName='bic_know_more'
                    buttonText={<Fragment>Know more</Fragment>}
                    buttonOnClick={() => {
                      setShowOverlay(true);
                    }}
                  />
                </div>
              </Fragment>
            )}
            <div className={style.startShoppingContainer}>
              <div className={style.startShoppingText}>
                Start shopping with Cardless EMI from your bank
              </div>
              <div className={style.lenderLogo}>
                <div className={style.logoContainer}>
                  <img
                    src={
                      lenderDetailsList && lenderDetailsList[0].lenderLogoIcon
                    }
                    className={style.lenderIcon}
                    alt='lender-logo'
                  />
                </div>
                {lenderDetailsList[1] && (
                  <div className={style.logoContainer1}>
                    <img
                      src={lenderDetailsList[1].lenderLogoIcon}
                      className={style.lenderIcon}
                      alt='lender-logo'
                    />
                  </div>
                )}
                {lendersRemaining > 0 && (
                  <div className={style.subText}>+{lendersRemaining}</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {showOverlay && (
        <OverlayScreen
          handleCloseOverlay={handleCloseOverlay}
          showOverlay={showOverlay}
          overlayHeight={overlayHeight}
          overlaySizeClassName={overlaySizeClassName}>
          <OverlayEmiDetails
            handleCloseOverlay={handleCloseOverlay}
            ntbAction={ntbAction}
            lenderDetailsList={lenderDetailsList}
          />
        </OverlayScreen>
      )}
    </Fragment>
  );
};

export default withBaseComponent(PreApprovedCard);



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/preApprovedCard/index.js